import { alertAnatomy as v } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as d, cssVar as s } from "@chakra-ui/styled-system";
import { transparentize as g } from "@chakra-ui/theme-tools";
const { definePartsStyle: l, defineMultiStyleConfig: h } = d(v.keys), r = s("alert-fg"), a = s("alert-bg"), f = l({
  container: {
    bg: a.reference,
    px: "4",
    py: "3"
  },
  title: {
    fontWeight: "bold",
    lineHeight: "6",
    marginEnd: "2"
  },
  description: {
    lineHeight: "6"
  },
  icon: {
    color: r.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "6"
  },
  spinner: {
    color: r.reference,
    flexShrink: 0,
    marginEnd: "3",
    w: "5",
    h: "5"
  }
}), n = (e) => {
  switch (e.toLowerCase()) {
    case "blue":
      return "gray";
    case "orange":
      return "orange";
    case "green":
      return "lime";
    case "red":
      return "red";
    default:
      return e;
  }
};
function i(e) {
  const { theme: t, colorScheme: c } = e, o = n(c), b = g("".concat(o, ".200"), 0.16)(t);
  return {
    light: "colors.".concat(o, ".50"),
    dark: b
  };
}
const u = l((e) => {
  const { colorScheme: t } = e, c = n(t), o = i(e);
  return {
    container: {
      [r.variable]: "colors.".concat(c, ".500"),
      [a.variable]: o.light,
      _dark: {
        [r.variable]: "colors.".concat(c, ".200"),
        [a.variable]: o.dark
      },
      border: "1px",
      borderColor: r.reference,
      borderRadius: "md"
    },
    icon: { color: r.reference },
    title: {
      color: r.reference
    },
    description: {
      color: r.reference
    }
  };
}), m = l((e) => {
  const { colorScheme: t } = e, c = n(t), o = i(e);
  return {
    container: {
      [r.variable]: "colors.".concat(c, ".500"),
      [a.variable]: o.light,
      _dark: {
        [r.variable]: "colors.".concat(c, ".200"),
        [a.variable]: o.dark
      }
    }
  };
}), p = l((e) => {
  const { colorScheme: t } = e, c = n(t), o = i(e);
  return {
    container: {
      [r.variable]: "colors.".concat(c, ".500"),
      [a.variable]: o.light,
      _dark: {
        [r.variable]: "colors.".concat(c, ".200"),
        [a.variable]: o.dark
      },
      paddingStart: "3",
      borderStartWidth: "4px",
      borderStartColor: r.reference
    }
  };
}), k = l((e) => {
  const { colorScheme: t } = e, c = n(t), o = i(e);
  return {
    container: {
      [r.variable]: "colors.".concat(c, ".500"),
      [a.variable]: o.light,
      _dark: {
        [r.variable]: "colors.".concat(c, ".200"),
        [a.variable]: o.dark
      },
      pt: "2",
      borderTopWidth: "4px",
      borderTopColor: r.reference
    }
  };
}), y = l((e) => {
  const { colorScheme: t } = e, c = n(t);
  return {
    container: {
      [r.variable]: "colors.white",
      [a.variable]: "colors.".concat(c, ".500"),
      _dark: {
        [r.variable]: "colors.gray.900",
        [a.variable]: "colors.".concat(c, ".200")
      },
      color: r.reference
    }
  };
}), S = l((e) => {
  const t = e.status, { colorScheme: c } = e, o = n(c);
  switch (t) {
    case "info":
      return {
        container: {
          [r.variable]: "colors.whiteAlpha.900",
          [a.variable]: "colors.coldGray.600",
          _dark: {
            [r.variable]: "colors.gray.900",
            [a.variable]: "colors.coldGray.200"
          },
          color: r.reference
        }
      };
    case "success":
      return {
        container: {
          [r.variable]: "colors.whiteAlpha.900",
          [a.variable]: "colors.lime.500",
          _dark: {
            [r.variable]: "colors.gray.900",
            [a.variable]: "colors.lime.200"
          },
          color: r.reference
        }
      };
    case "warning":
      return {
        container: {
          [r.variable]: "colors.whiteAlpha.900",
          [a.variable]: "colors.warning.500",
          _dark: {
            [r.variable]: "colors.gray.900",
            [a.variable]: "colors.warning.200"
          },
          color: r.reference
        }
      };
    case "error":
      return {
        container: {
          [r.variable]: "colors.whiteAlpha.900",
          [a.variable]: "colors.error.500",
          _dark: {
            [r.variable]: "colors.gray.900",
            [a.variable]: "colors.error.200"
          },
          color: r.reference
        }
      };
    default:
      return {
        container: {
          [r.variable]: "colors.whiteAlpha.900",
          [a.variable]: "colors.".concat(o != null ? o : "gray", ".500"),
          _dark: {
            [r.variable]: "colors.gray.900",
            [a.variable]: "colors.".concat(o != null ? o : "gray", ".200")
          },
          color: r.reference
        }
      };
  }
}), $ = {
  outline: u,
  subtle: m,
  "left-accent": p,
  "top-accent": k,
  solid: y,
  toast: S
}, x = h({
  baseStyle: f,
  variants: $,
  defaultProps: {
    variant: "outline"
  }
});
export {
  x as alertTheme
};
